/**
 * Utilidades para el BuscadorGlobal
 */

/**
 * Normaliza un resultado del API al formato interno del componente.
 * @param {Object} item - Item del stored procedure
 * @returns {Object} Item normalizado
 */
export const normalizarResultado = (item) => ({
  id: item.id,
  titulo: item.titulo,
  menu: item.menuGrupo,
  path: item.path,
  icono: item.icono,
  disabled: item.disabled,
  tipo: item.tipo,
  semCode: item.semCode,
  tituloModulo: item.tituloModulo || '',
});

/**
 * Normaliza una búsqueda reciente del localStorage.
 * @param {Object} item - Item del localStorage
 * @returns {Object} Item normalizado
 */
export const normalizarReciente = (item) => ({
  titulo: item.titulo,
  menu: item.menu,
  path: item.path,
  icono: item.icono,
  tipo: item.tipo,
  semCode: item.semCode,
  tituloModulo: item.tituloModulo,
});
